export default "__VITE_ASSET__C6YdTIM3__"